import classNames from 'classnames';
import * as React from 'react';
import { forwardRef } from 'react';
const CnList = (props, ref) => {
    const { children, prefix = 'cn-ui-m-', className, ...others } = props;
    return (React.createElement("div", { ...others, ref: ref, className: classNames(`${prefix}list`, className) }, children));
};
CnList.displayName = 'CnList';
export default forwardRef(CnList);
